import React from 'react';
import { H2 } from './basic/Text';
import { useMessageGetter } from 'react-message-context';
import styled from 'styled-components/macro';
import { Body2, H4 } from './common';
import { HousingQuestionsPictogram } from '../assets';

const UpdatePlaceholder = styled.div`
  padding-bottom: 30px;

  svg {
    margin-bottom: 16px;
  }
`;

const InfoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 14px;
  line-height: 16.8px;
`;

/* const ListContainer = styled.div`
  display: flex;

  dl {
    width: 50%;
  }

  dt {
    font-weight: 700;
    margin-top: 24px;
    margin-bottom: 8px;
  }

  dd {
    margin: 0;
  }

  dd:first-of-type {
    height: 35px;
  }

  span {
    display: block;
  }
`; */

const BasicBuildingInfo = () => {
  const t = useMessageGetter('');

  /*const hasSauna =
    housingInfo.features && housingInfo.features.some((feature) => feature.isExist && feature.name === 'buildingSauna');

  const apartmentLoading = apartment.loadState === LOAD_STATES.BUSY;
  const housingInfoLoading = housingInfo.loadState === LOAD_STATES.BUSY; */

  return (
    <InfoContainer>
      <H2>{t('housing.title')}</H2>
      <UpdatePlaceholder>
        <HousingQuestionsPictogram />
        <H4>{t('housing.update.title')}</H4>
        <Body2>{t('housing.update.description')}</Body2>
      </UpdatePlaceholder>
      {/* {apartmentLoading && housingInfoLoading ? (
        <Loader />
      ) : (
        <ListContainer>
          <dl>
            <dt>{t('home.address.title')}</dt>
            <dd>
              {apartment.info.address}{' '}
              <span>
                {apartment.info.zip} {capitalizeFirstLetter(apartment.info.city)}
              </span>
            </dd>
            <dt>{t('housing.basicinfo.floors')}</dt>
            <dd>{housingInfo.floors}</dd>
            <dt>{t('housing.basicinfo.apartmentcounts')}</dt>
            <dd>
              {housingInfo.apartmentcounts} {t('housing.basicInfo.amount')}
            </dd>
            <dt>{t('housing.basicinfo.elevator')}</dt>
            <dd>{housingInfo.elevator ? t('housing.yes') : t('housing.no')}</dd>
          </dl>
          <dl>
            <dt>{t('housing.basicinfo.buildingtype')}</dt>
            <dd>{housingInfo.buildingType || '-'}</dd>
            <dt>{t('housing.basicinfo.year')}</dt>
            <dd>{housingInfo.year || '-'}</dd>
            <dt>{t('housing.sauna.label')}</dt>
            <dd>{hasSauna ? t('housing.yes') : t('housing.no')}</dd>
            <dt>{t('housing.basicInfo.energyClass')}</dt>
            <dd>B2018</dd>
          </dl>
        </ListContainer>
      )} */}
    </InfoContainer>
  );
};

export default BasicBuildingInfo;
